import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import { AuthUser, ConfigData } from "./reducer";

const reducer = {
  AuthUser,
  ConfigData,
};

const rootReducer = combineReducers(reducer);

const persistConfig = {
  key: "root",
  storage,
  /** Config is refetched when needed; avoid persisting stale industries. */
  blacklist: ["ConfigData"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Skip the redux-persist housekeeping actions in the dev console — they fire
// on every page load / purge and just add noise.
const PERSIST_ACTIONS = [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER];
const logger = createLogger({
  collapsed: true,
  predicate: (_getState, action) => !PERSIST_ACTIONS.includes(action.type),
});

let middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: { ignoredActions: PERSIST_ACTIONS },
  }).concat(logger);

if (process.env.NODE_ENV === "production") {
  middleware = (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredActions: PERSIST_ACTIONS },
    });
}

export const store = configureStore({
  reducer: persistedReducer,
  middleware,
});

export const persistor = persistStore(store);
